import { render, staticRenderFns } from "./NormalSearchNav313.vue?vue&type=template&id=06af1136&scoped=true&"
import script from "./NormalSearchNav313.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav313.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af1136",
  null
  
)

export default component.exports